<template>
  <div>
    <v-row justify="start" align="center">
      <v-col cols="12">
        <v-banner
          :icon="isEnabledOrReadOnly ? 'view_headline' : 'edit'"
          v-if="selectedStandingOrder"
        >
          <span v-if="isEnabledOrReadOnly">Viewing</span>
          <span v-else>Creating</span>
          : {{ selectedStandingOrder.trolly_header_info.name }} ({{
            selectedStandingOrder.id
          }})
          <template v-slot:actions>
            <v-btn
              text
              color="error"
              exact
              @click="deleteStandingDialog = true"
              v-if="!isEnabledOrReadOnly"
            >
              <v-icon left>delete_forever</v-icon>Delete Standing Order
            </v-btn>
            <v-btn
              text
              color="error"
              exact
              @click="disableStandingDialog = true"
              v-if="isEnabledOnly"
            >
              <v-icon left>delete_forever</v-icon>Disable Standing Order
            </v-btn>
            <v-btn
              text
              color="blue darken-2"
              exact
              :to="{ name: 'StandingOrders' }"
              @click="currentTab = 0"
            >
              <v-icon left>arrow_back</v-icon>Back
            </v-btn>
          </template>
        </v-banner>
      </v-col>
      <v-col cols="12" md="12" sm="12" v-if="currentStandingTrolly">
        <v-alert
          type="success"
          class="mx-0 mt-4"
          outlined
          text
          v-if="standingOrderIsActive"
        >
          This is an <b> Active</b> Standing Order
        </v-alert>
        <DateAlert
          class="mt-4"
          :isStandingOrder="true"
          v-if="!isEnabledOrReadOnly"
        ></DateAlert>
        <MandatoryCategory
          class="mt-4"
          :isStandingOrder="true"
          v-if="!isEnabledOrReadOnly"
        ></MandatoryCategory>
        <MinimumValue class="mt-4" v-if="!isEnabledOrReadOnly"></MinimumValue>
      </v-col>

      <v-col md="12" sm="12">
        <StandingProgress
          :step="2"
          :markComplete="isEnabledOnly"
          v-if="!isEnabledOrReadOnly"
        ></StandingProgress>
      </v-col>

      <v-col v-if="loadingItems" cols="12" lg="12" xs="12">
        <v-card class="mx-auto" outlined height="100%" loading>
          <v-card-title>Loading Products...</v-card-title>
          <template slot="progress">
            <v-progress-linear
              color="blue darken-2"
              indeterminate
            ></v-progress-linear>
          </template>
        </v-card>
      </v-col>

      <v-col cols="12" md="12" xs="12" v-else>
        <v-tabs
          v-model="currentTab"
          color="blue darken-2"
          background-color="white"
          icons-and-text
          grow
        >
          <v-tab>
            Current Products
            <v-icon>mdi-format-list-checkbox</v-icon>
          </v-tab>
          <v-tab v-if="!isEnabledOrReadOnly">
            Add Products
            <v-icon>add</v-icon>
          </v-tab>

          <v-tab-item>
            <v-row justify="start" align="start">
              <v-col cols="12" lg="8" sm="12">
                <v-row justify="space-between" align="center">
                  <v-col v-if="totalBasketItems" cols="12">
                    <v-subheader style="width: 100%"
                      ><b>Basket Totals</b></v-subheader
                    >

                    <v-simple-table dense>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left">No. Items</th>
                            <th class="text-left">Total Qty</th>
                            <th class="text-right">Total Value</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>{{ totalBasketItems }}</td>
                            <td>{{ totalQty }}</td>
                            <td class="text-right">£{{ basketTotal }}</td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="12" md="4" sm="12">
                <v-row
                  justify="center"
                  align="center"
                  v-if="!isEnabledOrReadOnly"
                >
                  <v-col cols="12" lg="12" sm="12" v-if="totalBasketItems > 0">
                    <v-btn
                      color="blue darken-2"
                      class="white--text"
                      @click="confirmStandingOrder()"
                      :disabled="disableConfirm"
                      :loading="loadingConfirm"
                      block
                      large
                    >
                      <span>Confirm Standing Order</span>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>

              <v-divider></v-divider>
              <v-col cols="12" v-if="Object.values(basketItems).length == 0">
                <v-row>
                  <v-col cols="6" md="8" lg="9">
                    <v-banner>
                      <!-- <v-banner> -->
                      Your Standing Order has no products
                    </v-banner>
                  </v-col>
                  <v-col cols="6" md="3" lg="3">
                    <v-btn
                      outlined
                      class="white--text"
                      color="blue darken-2"
                      @click="currentTab = 1"
                    >
                      <v-icon left>add</v-icon>Add Products
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>

              <v-col
                v-else
                v-for="distNo in Object.keys(basketItems)"
                :key="distNo"
                cols="12"
                md="8"
                sm="12"
              >
                <v-row
                  justify="start"
                  align="start"
                  v-if="Object.keys(basketItems).length > 1"
                >
                  <v-subheader class="mx-6" style="width: 100%">
                    <b>{{
                      `Distributor: ${basketItems[distNo].distributor_name}`
                    }}</b>
                  </v-subheader>
                </v-row>
                <v-simple-table
                  dense
                  v-if="Object.keys(basketItems).length > 1"
                >
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">No. Items</th>
                        <th class="text-left">Total Qty</th>
                        <th class="text-right">Total Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{{ basketItems[distNo].distItems }}</td>
                        <td>{{ basketItems[distNo].distQty }}</td>
                        <td class="text-right">
                          £{{ basketItems[distNo].distValue }}
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
                <v-col
                  cols="12"
                  v-for="product in basketItems[distNo].items"
                  :key="product.id"
                >
                  <ProductBasket
                    @selectProduct="updateSelectedProduct($event)"
                    @deleteTrollyItem="updateDeleteItemDialog($event)"
                    v-bind:product="product"
                    v-bind:visible="true"
                    :isStandingOrder="true"
                    :isReadOnly="isEnabledOrReadOnly"
                  ></ProductBasket>
                </v-col>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item>
            <v-col cols="12" md="12" xs="12" class="hidden-md-and-down pt-4">
              <v-row justify="space-between" align="start">
                <v-col class="pt-0">
                  <v-btn
                    :loading="loadingGroup"
                    block
                    outlined
                    color="blue darken-2"
                    :to="{ name: 'StandingOrderGroups' }"
                  >
                    <v-icon left>mdi-group</v-icon>View by Group
                  </v-btn>
                </v-col>
                <v-col class="pt-0" v-if="!$store.getters.retrieveGuest">
                  <v-btn
                    :loading="loadingFavourites"
                    block
                    outlined
                    color="favourites"
                    @click="getFavouriteProducts()"
                  >
                    <v-icon left>mdi-heart</v-icon>
                    {{ favouritesText }}
                  </v-btn>
                </v-col>
                <v-col v-if="showPromotionsButton" class="pt-0">
                  <v-btn
                    :loading="loadingPromotions"
                    block
                    outlined
                    color="promotions"
                    @click="getPromotionalProducts()"
                  >
                    <v-icon left>mdi-sale</v-icon>{{ promoBtnText }}
                  </v-btn>
                </v-col>
                <v-col v-if="showNewProdsButton" class="pt-0">
                  <v-btn
                    :loading="loadingNewProducts"
                    block
                    outlined
                    color="green darken-2"
                    @click="getNewlyAvailableProducts()"
                  >
                    <v-icon left>fiber_new</v-icon>New Products
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" md="12" xs="12">
              <v-row justify="space-between" align="start">
                <v-col cols="12" class="pt-0">
                  <v-row justify="space-between" align="start" no-gutters>
                    <v-col class="text--secondary">
                      <div v-if="filteredProds.length">
                        {{ filteredProds.length }} Product<span
                          v-if="filteredProds.length > 1"
                          >s</span
                        >
                        Found

                        <span
                          v-if="
                            $store.getters[
                              'standingOrderSearch/retrieveSearchType'
                            ]
                          "
                        >
                          in
                          {{
                            $store.getters[
                              "standingOrderSearch/retrieveSearchType"
                            ]
                          }}
                        </span>
                      </div>
                    </v-col>
                    <v-col
                      class="text--secondary"
                      style="text-align: right"
                      v-if="pages"
                    >
                      Page {{ currentPage }} of {{ pages }}
                    </v-col>
                  </v-row>
                </v-col>

                <v-col cols="12" md="5" xs="12">
                  <v-form ref="searchForm" @submit.prevent="userSearchProduct">
                    <v-text-field
                      :loading="
                        $store.getters[
                          'standingOrderSearch/retrieveLoadingSearch'
                        ]
                      "
                      v-model="search"
                      ref="search"
                      :rules="searchRules"
                      placeholder="Product Search"
                      filled
                      clearable
                      @input="debounceSearch"
                      :error-messages="searchErrors"
                    >
                      <template slot="append">
                        <v-btn
                          icon
                          class="mr-0 ml-2 mb-1 p-0"
                          style="margin-top: -6px"
                          @click="userSearchProduct()"
                        >
                          <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                      </template>
                    </v-text-field>
                  </v-form>
                </v-col>

                <v-col v-if="enableFilters" cols="3" md="3" sm="3" class="pb-0">
                  <v-btn-toggle
                    v-model="showFilters"
                    borderless
                    style="width: 100%"
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      v-if="showFilters"
                      :value="false"
                      block
                      height="56px"
                    >
                      <v-icon :left="$vuetify.breakpoint.smAndUp"
                        >mdi-filter-remove-outline</v-icon
                      >
                      <span class="hidden-xs-only">Hide Filters</span>
                    </v-btn>

                    <v-btn v-else :value="true" block height="56px">
                      <v-icon :left="$vuetify.breakpoint.smAndUp"
                        >mdi-filter-outline</v-icon
                      >
                      <span class="hidden-xs-only">Show Filters</span>
                    </v-btn>
                  </v-btn-toggle>
                </v-col>
              </v-row>

              <v-row justify="space-between" align="start">
                <v-col
                  cols="12"
                  lg="3"
                  md="12"
                  class="pa-0"
                  v-if="enableFilters"
                >
                  <v-card v-if="showFilters" class="mx-auto" tile flat>
                    <v-navigation-drawer
                      floating
                      v-model="showFilters"
                      :app="!$vuetify.breakpoint.lgAndUp"
                    >
                      <v-list nav expand>
                        <v-subheader>
                          <v-list-item-content>
                            <v-list-item-title class="h6">
                              <v-icon left>mdi-filter-outline</v-icon>Product
                              Filters
                            </v-list-item-title>
                          </v-list-item-content>

                          <v-list-item-action
                            @click="showFilters = false"
                            class="hidden-lg-and-up"
                          >
                            <v-icon>clear</v-icon>
                          </v-list-item-action>
                        </v-subheader>
                        <v-btn
                          class="my-2"
                          block
                          outlined
                          color="error"
                          @click="
                            currentPage = 1;
                            resetFilters();
                          "
                          :disabled="
                            distributorFilters == 0 &&
                            productFilters.length == 0 &&
                            categoryFilters.length == 0
                          "
                          >Reset Filters</v-btn
                        >

                        <v-list-group
                          v-if="hasValidDistributorFilters"
                          color="blue darken-2"
                          prepend-icon="local_shipping"
                          v-model="showDistributors"
                        >
                          <template v-slot:activator>
                            <v-list-item-title>Distributors</v-list-item-title>
                          </template>

                          <v-radio-group v-model="distributorFilters">
                            <v-radio :value="null" color="blue darken-2">
                              <template v-slot:label>
                                <div>All</div>
                              </template>
                            </v-radio>

                            <v-radio
                              v-for="(filter, index) in $store.getters[
                                'retrieveDistributorsAvailable'
                              ]"
                              :key="index"
                              :value="parseInt(filter.number)"
                              color="blue darken-2"
                            >
                              <template v-slot:label>
                                <div>{{ filter.name }}</div>
                              </template>
                            </v-radio>
                          </v-radio-group>
                        </v-list-group>

                        <v-list-group
                          v-if="hasValidProductFilter"
                          color="blue darken-2"
                          prepend-icon="filter_list"
                          v-model="showGeneral"
                        >
                          <template v-slot:activator>
                            <v-list-item-title>General</v-list-item-title>
                          </template>

                          <v-list-item-group
                            v-model="productFilters"
                            color="blue darken-2"
                            multiple
                          >
                            <div
                              v-for="(filter, index) in generalFilters"
                              :key="index"
                            >
                              <v-list-item
                                v-if="filtersAvailable[filter.flag]"
                                @click="currentPage = 1"
                                :label="filter.title"
                                :value="filter.value"
                                class="mb-1"
                              >
                                <template v-slot:default="{ active }">
                                  <v-list-item-action>
                                    <v-checkbox
                                      :input-value="active"
                                      color="blue darken-2"
                                    >
                                      <template v-slot:append>
                                        <v-img
                                          contain
                                          width="24px"
                                          height="24px"
                                          :src="filter.image"
                                          style="max-width: 24px"
                                        />
                                      </template>
                                    </v-checkbox>
                                  </v-list-item-action>
                                  <v-list-item-content>
                                    <v-list-item-title>{{
                                      filter.title
                                    }}</v-list-item-title>
                                  </v-list-item-content>
                                </template>
                              </v-list-item>
                            </div>
                          </v-list-item-group>
                        </v-list-group>

                        <v-list-group
                          v-if="hasValidCategoryFilter"
                          prepend-icon="category"
                          v-model="showCategory"
                          color="blue darken-2"
                        >
                          <template v-slot:activator>
                            <v-list-item-title>Categories</v-list-item-title>
                          </template>

                          <v-list-item-group
                            color="blue darken-2"
                            v-model="categoryFilters"
                            multiple
                          >
                            <v-list-item
                              v-for="category in currentlySelectedGroup.categories"
                              :key="category.category_no"
                              @click="currentPage = 1"
                              :label="category.category_description"
                              :value="category.category_no"
                              class="mb-1"
                            >
                              <template v-slot:default="{ active }">
                                <v-list-item-action>
                                  <v-checkbox
                                    :input-value="active"
                                    color="blue darken-2"
                                  ></v-checkbox>
                                </v-list-item-action>

                                <v-list-item-content>
                                  <v-list-item-title>{{
                                    category.category_description
                                  }}</v-list-item-title>
                                </v-list-item-content>
                              </template>
                            </v-list-item>
                          </v-list-item-group>
                        </v-list-group>
                      </v-list>
                    </v-navigation-drawer>
                  </v-card>
                </v-col>

                <v-col
                  cols="12"
                  :lg="!enableFilters ? false : showFilters ? 9 : 12"
                  md="12"
                  xs="12"
                  class="pa-0"
                >
                  <v-layout row wrap justify-start>
                    <ProductGrid
                      v-for="product in filteredPage"
                      :isStandingOrder="true"
                      :key="product.prod_no"
                      v-bind:product="product"
                      v-bind:visible="true"
                      :showFilters="!enableFilters ? false : showFilters"
                    ></ProductGrid>
                  </v-layout>

                  <v-pagination
                    v-if="filteredProds.length > 0"
                    v-model="currentPage"
                    :length="pages"
                    prev-icon="mdi-menu-left"
                    next-icon="mdi-menu-right"
                    color="blue darken-2"
                  ></v-pagination>
                </v-col>
              </v-row>
            </v-col>
          </v-tab-item>
        </v-tabs>
      </v-col>

      <v-dialog v-model="deleteItemDialog" persistent max-width="400">
        <v-card color="background">
          <v-toolbar color="background" flat dense>
            <v-toolbar-title>Delete Item</v-toolbar-title>
            <v-spacer />
            <v-btn icon @click="deleteItemDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <div class="pa-4">
            <ProductName :product="selectedProduct"></ProductName>
          </div>
          <v-card-subtitle
            >Are you sure you want to delete this item from your standing
            order?</v-card-subtitle
          >
          <v-card-actions class="dialogActions">
            <v-btn text @click="deleteItemDialog = false">Cancel</v-btn>
            <v-spacer></v-spacer>
            <v-btn outlined color="error" @click="removeStandingItem()"
              >Yes</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="deleteStandingDialog" persistent max-width="400">
        <v-card>
          <v-toolbar color="background" flat dense>
            <v-toolbar-title>Delete Standing Order</v-toolbar-title>
            <v-spacer />
            <v-btn icon @click="deleteStandingDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-subtitle class="mt-4">
            Are you sure you want to delete standing order?
            <br />This action cannot be undone
          </v-card-subtitle>
          <v-divider />
          <v-card-actions>
            <v-btn text @click="deleteStandingDialog = false">Cancel</v-btn>
            <v-spacer></v-spacer>
            <v-btn outlined color="error" @click="delStandingOrder()"
              >Yes</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="disableStandingDialog" persistent max-width="400">
        <v-card>
          <v-toolbar color="background" flat dense>
            <v-toolbar-title>Disable Standing Order</v-toolbar-title>
            <v-spacer />
            <v-btn icon @click="disableStandingDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-subtitle class="mt-4">
            Are you sure you want to disable standing order?
          </v-card-subtitle>
          <v-divider />
          <v-card-actions>
            <v-btn text @click="disableStandingDialog = false">Cancel</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              outlined
              color="error"
              :loading="loadingDisable"
              @click="disableStandingOrder()"
              >Yes</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <v-bottom-navigation
      app
      fixed
      grow
      color="blue darken-2"
      class="hidden-lg-and-up"
    >
      <v-btn @click="focusSearch()">
        <span>Search</span>
        <v-icon>mdi-magnify</v-icon>
      </v-btn>

      <v-btn :to="{ name: 'StandingOrderGroups' }">
        <span>Groups</span>
        <v-icon>mdi-group</v-icon>
      </v-btn>

      <v-btn
        :loading="loadingFavourites"
        v-if="!$store.getters.retrieveGuest"
        @click="getFavouriteProducts()"
      >
        <span>Faves</span>
        <v-icon>mdi-heart</v-icon>
      </v-btn>

      <v-btn
        v-if="showPromotionsButton"
        :loading="loadingPromotions"
        @click="getPromotionalProducts()"
      >
        <span>{{
          promoBtnText == "Promotions" ? "Promos" : promoBtnText
        }}</span>
        <v-icon>mdi-sale</v-icon>
      </v-btn>

      <v-btn
        v-if="showNewProdsButton"
        :loading="loadingNewProducts"
        @click="getNewlyAvailableProducts()"
      >
        <span>New</span>
        <v-icon>fiber_new</v-icon>
      </v-btn>
    </v-bottom-navigation>
  </div>
</template>

<script>
import axios from "axios";
//import moment from "moment";
import { mapActions } from "vuex";
import StandingProgress from "@/components/order/standing/StandingProgress.vue";
import ProductGrid from "@/components/order/search/ProductGrid.vue";
import ProductBasket from "@/components/order/search/ProductBasket.vue";
import ProductName from "@/components/product/ProductName.vue";
import DateAlert from "@/components/order/DateAlert.vue";
import MinimumValue from "@/components/order/standing/MinimumStandingValue.vue";
import MandatoryCategory from "@/components/order/MandatoryCategory.vue";

export default {
  name: "StandingProducts",
  components: {
    StandingProgress,
    ProductGrid,
    ProductBasket,
    ProductName,
    DateAlert,
    MinimumValue,
    MandatoryCategory,
  },

  data() {
    return {
      currentTab: 0,
      loadingItems: false,
      deleteStandingDialog: false,
      disableStandingDialog: false,
      deleteItemDialog: false,
      selectedProduct: null,
      loadingDelete: false,
      search: "",
      searchRules: [
        //v => !!v || "Search can't be ",
        (v) =>
          (v &&
            v.length >= this.$store.getters.retrieveMinimumSearchCharacters &&
            v.length > 0) ||
          "Search must be at least " +
            this.$store.getters.retrieveMinimumSearchCharacters +
            " characters",
        (v) => /^[a-zA-Z0-9 ]*$/.test(v) || "Search must be alphanumeric only",
      ],
      searchErrors: [],

      loadingSearch: false,
      loadingGroup: false,
      loadingFavourites: false,
      loadingPromotions: false,
      loadingNewProducts: false,
      loadingConfirm: false,
      loadingDisable: false,

      showDistributors: true,
      showGeneral: true,
      showCategory: true,

      showFilters: this.$store.getters.retrieveProductFilters,

      filtersAvailable: {
        nut_coeliacs_flag: false,
        nut_diabetics_flag: false,
        nut_fair_trade_certified_flag: false,
        nut_halal_certified_flag: false,
        nut_kosher_certified_flag: false,
        nut_leaf_certified_flag: false,
        nut_local_certified_flag: false,
        nut_organic_certified_flag: false,
        nut_red_tractor_certified_flag: false,
        nut_uk_certified_flag: false,
        nut_vegans_flag: false,
        nut_vegetarians_flag: false,
      },

      generalFilters: [
        {
          value: "vegetarian",
          flag: "nut_vegetarians_flag",
          image: require("@/assets/filters/vegetarian.png"),
          title: "Vegetarian",
        },
        {
          value: "vegan",
          flag: "nut_vegans_flag",
          image: require("@/assets/filters/vegan.png"),
          title: "Vegan",
        },
        {
          value: "glutenFree",
          flag: "nut_coeliacs_flag",
          image: require("@/assets/filters/glutenFree.jpg"),
          title: "Gluten Free",
        },

        {
          value: "coeliac",
          flag: "nut_coeliacs_flag",
          image: require("@/assets/filters/coeliac.jpg"),
          title: "Coeliac",
        },

        {
          value: "fairTrade",
          flag: "nut_fair_trade_certified_flag",
          image: require("@/assets/filters/fairTrade.png"),
          title: "Fair Trade",
        },

        {
          value: "uk",
          flag: "nut_uk_certified_flag",
          image: require("@/assets/filters/uk.png"),
          title: "UK",
        },

        {
          value: "local",
          flag: "nut_local_certified_flag",
          image: require("@/assets/filters/local.jpg"),
          title: "Local",
        },

        {
          value: "redTractor",
          flag: "nut_red_tractor_certified_flag",
          image: require("@/assets/filters/redTractor.png"),
          title: "Red Tractor",
        },

        {
          value: "halal",
          flag: "nut_halal_certified_flag",
          image: require("@/assets/filters/halal.png"),
          title: "Halal",
        },

        {
          value: "kosher",
          flag: "nut_kosher_certified_flag",
          image: require("@/assets/filters/kosher.png"),
          title: "Kosher",
        },
      ],

      distributorFilters: 0,
      productFilters: [],
      categoryFilters: [],
    };
  },

  computed: {
    //  ...mapState(['standingOrderTrolly']),
    isCashCustomer() {
      if (
        this.$store.getters.retrieveIsCashCustomer ||
        this.$store.getters.retrieveIsCncCustomer ||
        this.$store.getters.retrieveIsPaymentWithOrderCustomer
      ) {
        return true;
      }
      return false;
    },

    promoBtnText() {
      let btnText = "PROMOTIONS";
      if (
        this.$store.getters.retrieveAllConfigs.promo_btn_text &&
        this.$store.getters.retrieveAllConfigs.promo_btn_text != ""
      ) {
        btnText = this.$store.getters.retrieveAllConfigs.promo_btn_text;
      }
      return btnText;
    },
    selectedStandingOrder() {
      if (this.$store.getters.retrieveCurrentStandingOrder) {
        return this.$store.getters.retrieveCurrentStandingOrder;
      }
      return false;
    },
    selectedStandingOrderDate() {
      if (this.selectedStandingOrder) {
        return this.selectedStandingOrder.trolly_header_info.order_date;
      }

      return false;
    },

    standingOrderIsActive() {
      if (
        this.selectedStandingOrder &&
        this.selectedStandingOrder.enabled == 1
      ) {
        return true;
      } else {
        return false;
      }
    },

    isEnabledOrReadOnly() {
      if (
        this.selectedStandingOrder.read_only == 1 ||
        this.selectedStandingOrder.enabled == 1
      ) {
        return true;
      }

      return false;
    },

    isReadOnly() {
      return (
        this.selectedStandingOrder.read_only == 1 &&
        this.selectedStandingOrder.enabled != 1
      );
    },

    isEnabledOnly() {
      return (
        this.selectedStandingOrder.enabled == 1 &&
        this.selectedStandingOrder.read_only != 1
      );
    },

    totalBasketItems() {
      if (this.currentStandingTrolly) {
        return this.currentStandingTrolly.totalItems;
      } else {
        return false;
      }
    },

    totalQty() {
      if (this.currentStandingTrolly) {
        return this.currentStandingTrolly.totalQty;
      } else {
        return 0;
      }
    },

    basketItems() {
      if (this.totalBasketItems) {
        return this.currentStandingTrolly.trolly_items;
      } else {
        return false;
      }
    },

    basketTotal() {
      if (this.totalBasketItems) {
        return this.currentStandingTrolly.totalValue;
      } else {
        return false;
      }
    },
    searchCharacters() {
      return 6;
    },

    currentPage: {
      get() {
        console.log("-- Page Getting");
        return (
          parseInt(this.$store.getters["standingOrderSearch/retrievePage"]) || 1
        );
      },
      set(value) {
        console.log("-- Page Changing");
        this.setPage(parseInt(value));
      },
    },

    currentlySelectedGroup() {
      return this.$store.getters["standingOrderSearch/retrieveSelectedGroup"];
    },

    enableFilters() {
      //Check if we have any valid filters available for selection
      console.log("-- Enable Filters checks");
      console.log(this.hasValidProductFilter);
      console.log(this.hasValidCategoryFilter);
      console.log(this.hasValidDistributorFilters);
      console.log("-- End Checks");

      if (
        this.hasValidProductFilter ||
        this.hasValidCategoryFilter ||
        this.hasValidDistributorFilters
      ) {
        //We do so enable the filters
        return true;
      }

      //We do not so hide it
      return false;
    },

    hasValidProductFilter() {
      console.log("-- Checking Product Filters");
      for (var element of this.generalFilters) {
        if (this.filtersAvailable[element.flag] == true) {
          console.log("-- Returning True");
          return true;
        }
      }

      return false;
    },

    hasValidCategoryFilter() {
      console.log("-- Checking Category Filters");
      if (this.currentlySelectedGroup) {
        if (this.currentlySelectedGroup.categories.length > 0) {
          console.log("-- Returning True");
          return true;
        }
      }

      return false;
    },

    hasValidDistributorFilters() {
      console.log("-- Checking Distributor Filters");
      //Only be true if we have multiple available
      if (
        this.$store.getters["retrieveDistributorsAvailable"].length > 1 &&
        this.$store.getters.retrieveShowDistributorFilters
      ) {
        console.log("-- Returning True");
        return true;
      }

      return false;
    },

    filteredProds() {
      return this.$store.getters["standingOrderSearch/retrieveProducts"].filter(
        this.filterProducts
      );
    },

    filteredPage() {
      let page = this.currentPage;
      let pageLength = this.pageLength;

      let originalFilter = this.filteredProds.slice(
        (page - 1) * pageLength,
        page * pageLength
      );

      return originalFilter;
    },

    pages() {
      return this.pageLength
        ? Math.ceil(this.filteredProds.length / this.pageLength)
        : 0;
    },

    pageLength() {
      let prodsPerPage = 15;
      if (this.$store.getters.retrieveAllConfigs.orders_products_per_page) {
        prodsPerPage = parseInt(
          this.$store.getters.retrieveAllConfigs.orders_products_per_page
        );
      }

      //This is our base products per page
      // -- But we want to tweak this based on our page size to fit evenly

      let prodsPerRow = 5;
      //lg2 md3 sm4 xs6

      switch (this.$vuetify.breakpoint.name) {
        case "lg":
          prodsPerRow = 5;
          break;

        case "md":
          prodsPerRow = 4;
          break;

        case "sm":
          prodsPerRow = 3;
          break;

        case "xs":
          prodsPerRow = 2;
          break;
      }

      let remainder = prodsPerPage % prodsPerRow;
      prodsPerPage -= remainder;

      return prodsPerPage;
    },

    orderDateLabel() {
      let label = "Choose a delivery date";

      if (this.$store.getters.retrieveIsCncCustomer) {
        label = "Choose a collection date";
      }

      return label;
    },

    currentStandingTrolly() {
      return this.$store.getters.retrieveStandingOrderTrolly;
    },

    disableConfirm() {
      if (!this.currentStandingTrolly.valid || !this.basketItems) {
        return true;
      }
      return false;
    },
    selectedDays() {
      if (this.$store.getters.retrieveStandingOrderRepeatDays.length > 0) {
        return this.$store.getters.retrieveStandingOrderRepeatDays;
      } else {
        return false;
      }
    },

    favouritesText() {
      return "Favourites";
    },

    showPromotionsButton() {
      let show = true;

      console.log("-- Show Promo?");
      console.log(this.$store.getters.retrieveAllConfigs.prom_show);

      if (this.$store.getters.retrieveCustomer) {
        if (
          this.$store.getters.retrieveAllConfigs.prom_show == 0 ||
          parseInt(
            this.$store.getters.retrieveCustomer.customer.ignore_promotions
          ) == 1
        ) {
          show = false;
        }
      } else {
        show = false;
      }

      return show;
    },

    showNewProdsButton() {
      let show = true;

      if (this.$store.getters.retrieveAllConfigs.new_products_show == 0) {
        show = false;
      }

      return show;
    },
  },

  mounted() {
    this.getFiltersAvailable();
  },

  methods: {
    ...mapActions([
      "getStandingOrderTrolly",
      "setSnackbar",
      "deleteStandingOrder",
      "enableStandingOrder",
      "getStandingOrder",
      "disableSO",
    ]),

    ...mapActions("standingOrderSearch", [
      "setPage",
      "setAutoload",
      "setGroups",
      "clearProducts",
      "productSearch",
      "getCatPriceList",
      "getMandatoryCategory",
      "getGroupPriceList",
      "getFavourites",
      "getPromotions",
      "getNewProducts",
    ]),

    capitalizeString(str) {
      if (str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
      }
    },
    updateSelectedProduct(prod) {
      this.selectedProduct = prod;
    },

    updateDeleteItemDialog(newProduct) {
      this.selectedProduct = newProduct;
      this.deleteItemDialog = true;
    },
    resetEditInformation() {
      console.log("-- Resetting Edit Info");
      this.currentTab = 0;
      this.setPage = 1;
      this.clearProducts();
    },

    filterProducts(product) {
      let productFilters = this.productFilters;

      //Default our product to show
      var showProduct = true;

      if (productFilters.includes("vegetarian")) {
        if (product.vegetarian != true) {
          showProduct = false;
        }
      }

      if (productFilters.includes("vegan")) {
        if (product.vegan != true) {
          showProduct = false;
        }
      }

      if (productFilters.includes("glutenFree")) {
        if (product.glutenFree != true) {
          showProduct = false;
        }
      }

      if (productFilters.includes("coeliac")) {
        if (product.coeliac != true) {
          showProduct = false;
        }
      }

      if (productFilters.includes("fairTrade")) {
        if (product.fairTrade != true) {
          showProduct = false;
        }
      }

      if (productFilters.includes("uk")) {
        if (product.uk != true) {
          showProduct = false;
        }
      }

      if (productFilters.includes("local")) {
        if (product.local != true) {
          showProduct = false;
        }
      }

      if (productFilters.includes("redTractor")) {
        if (product.redTractor != true) {
          showProduct = false;
        }
      }

      if (productFilters.includes("kosher")) {
        if (product.kosher != true) {
          showProduct = false;
        }
      }

      if (productFilters.includes("halal")) {
        if (product.halal != true) {
          showProduct = false;
        }
      }

      if (this.distributorFilters != 0) {
        if (this.distributorFilters != parseInt(product.distributor_no)) {
          showProduct = false;
        }
      }

      if (this.categoryFilters.length > 0) {
        if (this.categoryFilters.includes(product.product_category) == 0) {
          showProduct = false;
        }
      }

      return showProduct;
    },

    maxValueHint(item) {
      switch (item.qty_type) {
        case "B":
          if (item.box_max != 9999 && item.box_max != undefined) {
            return "Max Qty: " + this.product.box_max;
          }
          break;
        case "K":
          if (item.kilo_max != 9999 && item.kilo_max != undefined) {
            return "Max Qty: " + this.product.kilo_max;
          }
          break;
        case "E":
          if (item.each_max != 9999 && item.each_max != undefined) {
            return "Max Qty: " + item.each_max;
          }
          break;
      }

      return "";
    },

    debounceSearch() {
      if (this.$store.getters.retrieveMinimumSearchConfig > 0) {
        clearTimeout(this.debounce);
        this.debounce = setTimeout(() => {
          console.log(this.search);
          this.userSearchProduct();
        }, 600);
      }
    },

    async delStandingOrder() {
      console.log("Delete SO");

      let response = await this.deleteStandingOrder();

      if (response) {
        this.setSnackbar({ text: "Order Cancelled" });
        this.$router.push({ name: "StandingOrders" });
      } else {
        this.setSnackbar({
          color: "error",
          text: "Error cancelling order",
        });
      }

      this.deleteStandingDialog = false;
    },

    async getFavouriteProducts() {
      this.resetFilters();
      this.loadingFavourites = true;

      let stringPayload = JSON.stringify({
        userId: this.$store.getters.retrieveUser.userNum,
        sessionKey: this.$store.getters.retrieveUser.sessionKey,
        orderDate: this.selectedStandingOrderDate,
        customerNo: this.$store.getters.retrieveSelectedCustomer,
      });

      await this.getFavourites(stringPayload);

      this.loadingFavourites = false;
    },

    async getPromotionalProducts() {
      this.resetFilters();
      this.loadingPromotions = true;

      let stringPayload = JSON.stringify({
        userId: this.$store.getters.retrieveUser.userNum,
        sessionKey: this.$store.getters.retrieveUser.sessionKey,
        orderDate: this.selectedStandingOrderDate,
        customerNo: this.$store.getters.retrieveSelectedCustomer,
      });

      await this.getPromotions(stringPayload);

      this.loadingPromotions = false;
    },

    async getNewlyAvailableProducts() {
      this.resetFilters();
      this.loadingNewProducts = true;

      let stringPayload = JSON.stringify({
        userId: this.$store.getters.retrieveUser.userNum,
        sessionKey: this.$store.getters.retrieveUser.sessionKey,
        orderDate: this.selectedStandingOrderDate,
        customerNo: this.$store.getters.retrieveSelectedCustomer,
      });

      await this.getNewProducts(stringPayload);
      this.loadingNewProducts = false;
    },

    focusSearch() {
      console.log(this.$refs.search);
      this.$refs.search.focus();

      console.log(this.$refs.search);
      //this.$refs.search.$el.select();
    },

    async getFiltersAvailable() {
      let stringPayload = JSON.stringify({
        userId: this.$store.getters.retrieveUser.userNum,
        sessionKey: this.$store.getters.retrieveUser.sessionKey,
        customerNo: this.$store.getters.retrieveSelectedCustomer,
      });
      const params = new URLSearchParams();
      params.append("params", stringPayload);

      await axios
        .post("get-certified-icons", params)
        .then((response) => {
          console.log("-- Certified Icons");
          console.log(response.data);

          this.filtersAvailable = response.data.icons;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async userSearchProduct() {
      if (this.$refs.searchForm.validate()) {
        this.resetFilters();

        let stringPayload = JSON.stringify({
          userId: this.$store.getters.retrieveUser.userNum,
          sessionKey: this.$store.getters.retrieveUser.sessionKey,
          search: this.search,
          orderDate: this.selectedStandingOrderDate,
        });

        let response = await this.productSearch(stringPayload);

        if (response) {
          this.searchErrors = [];
        } else {
          this.searchErrors.push("Search Error");
        }
      }
    },

    resetFilters() {
      this.distributorFilters = 0;
      this.productFilters = [];
      this.categoryFilters = [];
    },

    async removeStandingItem() {
      this.loadingDelete = true;
      this.deleteItemDialog = false;
      let stringPayload = JSON.stringify({
        sessionKey: this.$store.getters.retrieveUser.sessionKey,
        userId: this.$store.getters.retrieveUser.userNum,
        trollyId: this.$store.getters.retrieveStandingOrderTrolly.id,
        trollyItemId: this.selectedProduct.id,
        // prodNo: item.prod_no,
        // qtyType: item.qty_type,
      });

      const params = new URLSearchParams();
      params.append("params", stringPayload);

      let response = await axios.post("del-trolly-item", params);

      if (response.data.success) {
        this.setSnackbar({ text: "Item removed from Standing Order" });
        this.getStandingOrderTrolly();
      } else {
        this.setSnackbar({
          color: "error",
          text: "Error removing item from Standing Order",
        });
      }

      this.loadingDelete = false;

      return;
    },

    async confirmStandingOrder() {
      this.loadingConfirm = true;
      console.log("Enabling standing order...");

      if (this.isCashCustomer) {
        this.loadingConfirm = false;
        this.$router.push({ name: "StandingOrderConfirm" });
      } else {
        let enableResponse = await this.enableStandingOrder();
        console.log(enableResponse);
        if (enableResponse.success == true) {
          this.setSnackbar({ text: "Standing Order Activated" });
          this.loadingConfirm = false;
          //go to standing orders page
          this.$router.push({ name: "StandingOrders" });
        } else {
          this.setSnackbar({
            color: "error",
            text: enableResponse.messages[0],
          });
          this.loadingConfirm = false;
        }
      }
    },

    async disableStandingOrder() {
      this.loadingDisable = true;
      let disableResponse = await this.disableSO();
      if (disableResponse.success) {
        //get the standing order
        let response = await this.getStandingOrder();

        if (response.success) {
          this.setSnackbar({ text: "Standing Order Disabled" });
        } else {
          this.setSnackbar({
            color: "error",
            text: response.messages[0],
          });
        }
        this.loadingDisable = false;
      } else {
        this.setSnackbar({
          color: "error",
          text: disableResponse.messages[0],
        });
      }

      this.disableStandingDialog = false;
    },
  },
  async activated() {
    //When Activated we want to refresh
    this.loadingItems = true;
    let trollyResponse = await this.getStandingOrderTrolly();

    console.log(trollyResponse);
    this.loadingItems = false;
  },
};
</script>

<style lang="sass" scoped>
.active-select
  border-color: #f57c00 !important
</style>